import React from "react";
import "./HandbookStepsSlasSection.css";

const stepsData = [
  {
    title: "Ticket/Issue Raised",
    description: "Acknowledge in 10 min (auto), reply in 2 hr (human).",
  },
  {
    title: "Investigation",
    description: "Review, ask for details, update the user regularly.",
  },
  {
    title: "Resolution",
    description:
      "Most issues closed in 2 business days (critical cases: 4 hr).",
  },
  {
    title: "Escalation",
    description:
      "Level up to manager or compliance for urgent/complex cases. Never promise what you can’t deliver!",
  },
  {
    title: "Closure & Feedback",
    description:
      "Confirm outcome, log actions, invite feedback for improvement.",
  },
];

const HandbookStepsSlasSection = () => {
  return (
    <section className="_hSect_k1A_">
      <div className="_hCont_l2B_">
        <h2
          className="_hTitle_m3C_"
          style={{ paddingBottom: "1.5rem", marginBottom: "2.2rem" }}
        >
          Support Steps & SLAs
        </h2>
        <ol className="_hStepList_n4C_">
          {stepsData.map((step, index) => (
            <li key={index} className="_hStepItem_o5D_">
              <div className="_hStepContent_p6E_">
                <h3 className="_hStepTitle_q7F_">{step.title}</h3>
                <p className="_hStepDesc_r8G_">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HandbookStepsSlasSection;
